import { makeStyles } from 'tss-react/mui';

import { ScreenSize } from '@/styles/legacyComponentLibraryTheme';

const lightBlueFractalImageDesktop =
  '/cmsAssets/assets/img/BackgroundImages/LightBlueFractalDesktop.png';
const lightBlueFractalImageMobile =
  '/cmsAssets/assets/img/BackgroundImages/LightBlueFractalDesktop.png';
const offWhiteFractalDesktop =
  '/cmsAssets/assets/img/BackgroundImages/OffWhiteFractalDesktop.png';
const offWhiteFractalMobile =
  '/cmsAssets/assets/img/BackgroundImages/OffWhiteFractalDesktop.png';

const useStyles = makeStyles({ name: 'MuiSection' })(
  ({ brandColors, breakpoints, typography }) => ({
    LightBlueFractal: {
      backgroundImage: `url('${lightBlueFractalImageDesktop}')`,
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        backgroundImage: `url('${lightBlueFractalImageMobile}')`,
      },
    },
    OffWhiteFractal: {
      backgroundImage: `url('${offWhiteFractalDesktop}')`,
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        backgroundImage: `url('${offWhiteFractalMobile}')`,
      },
    },
    OffWhite: {
      backgroundColor: brandColors.offWhite,
    },
    grayLine: {
      borderBottom: `${typography.pxToRem(1)} solid ${brandColors.gray}`,
    },
    White: {
      backgroundColor: brandColors.white,
    },
    LightBlue: {
      backgroundColor: brandColors.chargeBlue,
    },
    hide: {
      display: 'none',
    },
  })
);

export default useStyles;
